import { Provider } from '@/features/game-context/types';
import {
  ERROR_TYPE,
  getErrorType,
} from '@/features/game-window-integration/helpers/error-mapping';
import {
  FusionErrorPayload,
  FusionEvents,
  FusionPayload,
} from '@/features/game-window-integration/providers/fusion/types';
import { WrapperProxy } from '@/features/wrapper-proxy/wrapper-proxy';

const handleGameLoad = () => {
  WrapperProxy.setGameLoaded();
};

const handleMuteHasChanged = (payload: FusionPayload) => {
  const { data } = payload || {};
  WrapperProxy.setAudio(!data);
};

const handleRoundStart = () => {
  WrapperProxy.setSpinInProgress(true);
};

const handleRoundEnd = () => {
  WrapperProxy.setSpinInProgress(false);
};

const handleQuit = () => {
  WrapperProxy.setGameLauncherClosed();
};

const handleGameError = (payload: FusionPayload) => {
  const { data: { Status: { UniqueErrorCode, ErrType } = {} } = {} } =
    (payload || {}) as FusionErrorPayload;

  const errorCode = UniqueErrorCode || ErrType;

  if (!errorCode) {
    return;
  }

  WrapperProxy.setProviderError({
    display: true,
    errorCode: errorCode.toString(),
    errorMessage: getErrorType(errorCode, Provider.FUSION, true),
    errorType: getErrorType(errorCode, Provider.FUSION, false, payload),
  });

  if (
    getErrorType(errorCode, Provider.FUSION, false, payload) ===
    ERROR_TYPE.INSUFFICIENT_FUNDS
  ) {
    WrapperProxy.setSpinInProgress(false);
  }
};

export const fusionEventMapper: Array<
  [FusionEvents, (payload?: FusionPayload) => void]
> = [
  [FusionEvents.APPLICATION_READY, handleGameLoad],
  [FusionEvents.SOUND_CHANGED, handleMuteHasChanged],
  [FusionEvents.SPIN_IN_PROGRESS, handleRoundStart],
  [FusionEvents.SPIN_IN_PROGRESS_ENDED, handleRoundEnd],
  [FusionEvents.GAME_RESUMED, handleRoundEnd],
  [FusionEvents.GAME_ERROR, handleGameError],
  [FusionEvents.GAME_ERROR_EVENT, handleGameError],
  [FusionEvents.TICKET_RECEIVED, handleGameError],
  [FusionEvents.CLOSE, handleQuit],
];
